import DOMPurify from 'dompurify';

const MULTIMEDIA_SANITIZATION_CONFIG_FORBID_TAGS = [
    // Ejecución de código
    'script',
    'noscript',

    // Embeds externos
    'iframe',
    'object',
    'embed',

    // Formularios / inputs
    'form',
    'input',
    'textarea',
    'select',
    'option',
    'button',
    'label',

    // Multimedia innecesaria
    'video',
    'audio',
    'source',
    'track',

    // Interactividad web
    'canvas',
    'svg', // importante: svg puede ser vector de XSS
    'details',
    'summary',

    // Meta
    'meta',
    'link',
];

const MULTIMEDIA_SANITIZATION_CONFIG_FORBID_ATTR = [
    // Eventos JS
    'onerror',
    'onclick',
    'onload',
    'onmouseover',
    'onfocus',
    'onmouseenter',
    'onkeydown',
    'onkeyup',
    'onkeypress',
    'onchange',
    'onsubmit',

    // JS URLs
    'srcdoc',
    'formaction',
];

const BASE_SANITIZATION_CONFIG = {
    FORBID_TAGS: MULTIMEDIA_SANITIZATION_CONFIG_FORBID_TAGS,
    FORBID_ATTR: MULTIMEDIA_SANITIZATION_CONFIG_FORBID_ATTR,
};

export const sanitizeHTMLBase = (html: string) => {
    return DOMPurify.sanitize(html, BASE_SANITIZATION_CONFIG);
};

export const sanitizeHTMLforDescriptions = (html: string) => {
    //capar también las imágenes y links
    const config = {
        FORBID_TAGS: [
            ...MULTIMEDIA_SANITIZATION_CONFIG_FORBID_TAGS,
            'img',
            'a',
        ],
        FORBID_ATTR: [...MULTIMEDIA_SANITIZATION_CONFIG_FORBID_ATTR],
    };

    return DOMPurify.sanitize(html, config);
};
